import { IHttpApi } from '@cian/http-api';
import { OutsideClick } from '@cian/outside-click-component';
import { Popup, PopupArrow } from '@cian/popup-component';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { ChatWidget } from '../../common/components/chat_widget/chat_widget';
import { IOfferHelper } from '../../presenter';
import { IAgentAvailability, IOffer } from '../../types/offer';
import { getFormattedPhoneNumber, phoneToChatFromat } from '../../utils/format';
import { IStartChatPopupTracking } from './tracking';

const styles = require('./index.css');

declare global {
  //tslint:disable-next-line:interface-name
  interface Window {
    waitForLoginPopup?(type?: string): void;
  }
}

export interface IStartChatButtonProps {
  trackingLabel?: string;
  isAuthorised?: boolean;
  disabled?: boolean;
  defaultPhone?: string;
  defaultEmail?: string;
  showPushNotification?: boolean;
}

export interface IStartChatButtonState {
  showChats: boolean;
}

export interface IStartChatButtonContext {
  httpApi: IHttpApi;
  offer: IOffer;
  offerHelper: IOfferHelper;
  api: {
    tracking: IStartChatPopupTracking;
  };
}

export class StartChatPopup extends React.PureComponent<IStartChatButtonProps, IStartChatButtonState> {

  public context: IStartChatButtonContext;

  public static contextTypes = {
    api: PropTypes.object,
    httpApi: PropTypes.object,
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
  };

  public state = {
    showChats: false,
  };

  public render() {
    const { defaultPhone, defaultEmail, showPushNotification } = this.props;
    const { httpApi, offer, offerHelper } = this.context;
    const phone = offerHelper.presenters.getPhone();

    return (
      <div>
        {this.state.showChats &&
          <OutsideClick
            onOutsideClick={this.handleClickOutside}
          >
            <Popup arrow={PopupArrow.RIGHT} containerStyle={styles['popup']}>
              <ChatWidget
                defaultPhone={phoneToChatFromat(defaultPhone)}
                defaultEmail={defaultEmail}
                agentAvailability={getAvailAbility(offer)}
                httpApi={httpApi}
                isOwnOfferChat={checkForOwnChat(offer)}
                offerId={offer.cianId}
                onClose={this.handleClickOutside}
                userPhone={phone ? getFormattedPhoneNumber(phone) : undefined}
                onMessageSent={this.handleSent}
                showPushNotification={showPushNotification}
              />
            </Popup>
          </OutsideClick>
        }
        <div onClick={this.handleWriteMessageClick}>
          {this.props.children}
        </div>
      </div>
    );
  }

  private handleSent = (chatId: string) => {
    const { tracking } = this.context.api;

    if (tracking && tracking.trackFirstMessageSent) {
      tracking.trackFirstMessageSent(this.props.trackingLabel, chatId);
    }
  }

  private handleWriteMessageClick = () => {
    if (!this.props.disabled) {
      const { tracking } = this.context.api;

      if (tracking && tracking.trackFirstMessageClick) {
        tracking.trackFirstMessageClick(this.props.trackingLabel);
      }
      if (this.props.isAuthorised === false && window.waitForLoginPopup) {
        window.waitForLoginPopup('chats');
      } else {
        if (tracking && tracking.trackFirstMessageOpen) {
          tracking.trackFirstMessageOpen(this.props.trackingLabel);
        }
        this.setState({showChats: true});
      }
    }
  }

  private handleClickOutside = () => {
    this.setState({showChats: false});
  }
}

function getAvailAbility(offer: IOffer | null): IAgentAvailability | null {
  return offer && offer.user ? offer.user.agentAvailability : null;
}

function checkForOwnChat(offer: IOffer | null, userId?: number): boolean {
  return  userId !== undefined && (offer && offer.userId) === userId;
}
